import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PS } from '../theme';
import { Avatar, CreditMeter } from '../lib/ui';
import { Icon } from '../lib/icons';
import MemberLayout from '../components/MemberLayout';
import { useAuth } from '../auth/AuthContext';
import { useFetch } from '../lib/useFetch';

function Row({ icon: IcoC, label, sub, onClick, testid, danger }) {
  return (
    <div data-testid={testid} onClick={onClick} className="ps-press" style={{ display: 'flex', gap: 14, alignItems: 'center', padding: '14px 16px', borderBottom: `1px solid ${PS.lineSoft}` }}>
      <div style={{ width: 36, height: 36, borderRadius: 12, background: danger ? 'oklch(0.62 0.12 28 / 0.12)' : PS.panel, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <IcoC size={18} stroke={danger ? PS.danger : PS.ink} />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13.5, fontWeight: 600, color: danger ? PS.danger : PS.text }}>{label}</div>
        {sub && <div style={{ fontSize: 11, color: PS.textMuted, marginTop: 1 }}>{sub}</div>}
      </div>
      <Icon.chevronR size={16} stroke={PS.textDim} />
    </div>
  );
}

export default function Profile() {
  const nav = useNavigate();
  const { user, logout } = useAuth();
  const { data: memberships } = useFetch('/me/memberships');
  const { data: hosting } = useFetch('/me/hosting');
  const { data: adminInfo } = useFetch('/admin/me');
  const firstCircle = memberships?.[0]?.circle_id;
  const hostCircle = hosting?.[0]?.circle_id;

  return (
    <MemberLayout>
      <div style={{ padding: '14px 20px 12px', flexShrink: 0 }}>
        <div style={{ fontSize: 22, fontWeight: 600, letterSpacing: -0.3 }}>ฉัน</div>
      </div>
      <div style={{ flex: 1, overflow: 'auto', paddingBottom: 20 }}>
        <div className="ps-fade-up" style={{ margin: '0 16px 16px', padding: 20, background: PS.ink, color: PS.page, borderRadius: 22, position: 'relative', overflow: 'hidden' }}>
          <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
            <Avatar name={user?.name} size={56} />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 18, fontWeight: 600 }}>{user?.name}</div>
              <div style={{ fontSize: 12, color: 'rgba(245,241,234,0.6)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{user?.email}</div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginTop: 18, paddingTop: 16, borderTop: '1px solid rgba(245,241,234,0.12)' }}>
            <div style={{ filter: 'invert(1) hue-rotate(180deg)', opacity: 0.92 }}><CreditMeter score={user?.credit_score || 720} size={76} /></div>
            <div>
              <div style={{ fontSize: 11, color: 'rgba(245,241,234,0.6)', textTransform: 'uppercase', letterSpacing: 1 }}>Credit Score</div>
              <div style={{ fontSize: 13, fontWeight: 600, marginTop: 4 }}>ดีเยี่ยม · จ่ายตรง {user?.on_time_pct || 100}%</div>
              <div style={{ fontSize: 11, color: 'rgba(245,241,234,0.6)', marginTop: 2 }}>{memberships?.length || 0} วงที่เข้าร่วม</div>
            </div>
          </div>
          <div style={{ position: 'absolute', right: -24, top: -24, width: 110, height: 110, border: '1px solid rgba(245,241,234,0.08)', transform: 'rotate(45deg)' }} />
        </div>

        <div style={{ margin: '0 16px', background: PS.surface, border: `1px solid ${PS.line}`, borderRadius: 18, overflow: 'hidden' }}>
          <Row testid="profile-wallet" icon={Icon.wallet} label="การจ่ายเงิน & สลิป" sub="ดูยอดงวดนี้และแนบหลักฐาน" onClick={() => nav('/app/wallet')} />
          <Row testid="profile-vault" icon={Icon.shield} label="ห้องนิรภัยหลักฐาน" sub="ไทม์ไลน์ event พร้อม hash" onClick={() => firstCircle ? nav(`/app/circle/${firstCircle}/vault`) : nav('/app/discover')} />
          <Row testid="profile-learn" icon={Icon.doc} label="คู่มือเล่นแชร์ปลอดภัย" sub="คำศัพท์ · วิธีคิดดอก · กฎหมาย · red flags" onClick={() => nav('/app/learn')} />
          {hostCircle && <Row testid="profile-host" icon={Icon.coin} label="คอนโซลท้าวแชร์" sub={`จัดการ ${hosting.length} วงที่คุณเปิด`} onClick={() => nav(`/app/host/${hostCircle}`)} />}
          <Row testid="profile-about" icon={Icon.info} label="บทบาทของ Peershare" sub="custodian · ไม่ใช่คู่สัญญา" onClick={() => nav('/about')} />
        </div>

        <div style={{ margin: '14px 16px', background: PS.surface, border: `1px solid ${PS.line}`, borderRadius: 18, overflow: 'hidden' }}>
          {adminInfo?.is_admin && <Row testid="profile-admin" icon={Icon.shield} label="ผู้ดูแลระบบ" sub="ตั้งค่าการแสดงข้อมูล test agent (sim)" onClick={() => nav('/app/admin')} />}
          <Row testid="profile-logout" icon={Icon.logout} label="ออกจากระบบ" onClick={logout} danger />
        </div>
      </div>
    </MemberLayout>
  );
}
